import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KuiToggleComponent } from './toggle.component';

@NgModule({
    imports: [CommonModule, FormsModule],
    exports: [KuiToggleComponent],
    declarations: [KuiToggleComponent],
})
export class KuiToggleModule { }
